import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import API from "../library/ApiManager";
import { Config } from "../Config";
//import { Tmp } from '../tmp/Tmp';
import Fnc from "../library/Functions";
import Loading from "./Loading";

/**
 * Componente principale dell'applicazione Carrello.
 * Gestisce tutte le parti della pagina che sono modularizzate e separate in componenti secondari.
 * Nel file Confing.js della root, sono presenti impostazioni generali di primaria importanza per il funzionamento di tutte le parti.
 *
 * @version 1.0.0
 * @author [Davide Pirola]
 */
function Bridge() {
  const [searchParams, setSearchParams] = useSearchParams();
  //const [products, setProducts] = useState(null);
  const navigate = useNavigate();
  const [loadingState, setLoadingState] = useState("open");
  const prodRegistration = [
    {
      code: "SDIYF",
      path: Fnc.currEnv().registrationSito,
      pathDirect: Fnc.currEnv().areaClientiSDIYFPath,
    },
    {
      code: "CMFTF",
      path: Fnc.currEnv().registrationCampagna,
      pathDirect: Fnc.currEnv().areaClientiCMFTFPath,
    },
  ];
  const errStep = Config.stepList.find(function (el) {
    return el.idx === -1;
  });
  const extraParams = ["idEditoriale", "idDuda", "advertiseId", "advStartDate"]; //parametri extra che possono arrivare da area clienti per prodotti SDIY, AWCR, CMFT2/3 e CMT
  //prodotti che fanno semplicemente fare una redirect su altre pagine (Fonte:Olcelli)
  const prodForceRedirect = [
    {
      code: "HOMEW",
      path: "https://www.pgcasa.it/come_funziona_azienda",
    },
    {
      code: "CRMW",
      path: "https://www.italiaonline.it/provisioning/",
    },
  ];

  useEffect(() => {
    // Similar to componentDidMount and componentDidUpdate:

    API.getUser((usr) => {
      //-------- GESTIONE REDIRECT FORZATA
      forceRedirect();

      //-------- GESTIONE PRODOTTI BRIDGE
      API.getAllProducts((prods) => {
        //setProducts(data);
        doJob(usr, prods);
      });
    });
  }, []); //empty array => chiama solo una volta. Senza la chiama ad ogni cambiamento

  //funzione che scorre un array di eccezioni che scatenano una semplice redirect "forzata" e li controlla con i codici passati in querystring. Al primo match, scatta il cambio pagina.
  function forceRedirect() {
    let codes = searchParams.get("codes");
    let codesArr = codes && codes !== null ? codes.split(",") : [];
    codesArr.forEach((code) => {
      const found = prodForceRedirect.find((p) => {
        return p.code === code;
      });
      if (found && found !== null) {
        window.location.href = found.path;
      }
    });
  }

  function doJob(usr, prods) {
    let isLogged = usr && usr.response.code === "OK";
    let piva = usr && usr.response.code === "OK" && usr.user && usr.user != null ? usr.user.pIva : null;
    let codComm = searchParams.get("cc");
    let qta = searchParams.get("q");
    let codes = searchParams.get("codes");
    let codesArr = codes && codes !== null ? codes.split(",") : [];
    let isMultiProducts = codesArr.length > 1;
    let isFreeProd = false;

    // Traccia pagina vista su Google Analytics
    Fnc.gaPageview("Bridge", document.location.href, document.location.pathname);
    // Traccia pagina vista su WT
    Fnc.wtPageview();

    let pObjToBuy = [];
    let redirPath = Fnc.currEnv().basketHome; //HOME
    codesArr.forEach((code) => {
      // ======= GESTIONE PRODOTTI FREE CHE NECESSITANO REGISTRAZIONE ========
      let exc = prodRegistration.filter((e) => e.code === code);
      isFreeProd = exc && exc.length > 0;
      if (isFreeProd) redirPath = exc[0].path; //prendo l'ultimo di una lista. I free dovrebbero solo essere uno alla volta senza altri codici
      // =======

      let isBundle = prods.filter((e) => e.bundleCode === code).length > 0;
      let correlationId = Fnc.generateCorrelationId(code);
      if (isBundle) {
        //ho un codice bundle, devo recuperare tutti i singoli prodotti da aggiungere al carrello
        let filtered = prods.filter((e) => e.bundleCode === code); //c'è il codice tra i prodotti, ma non è associato ad un bundle
        if (filtered && filtered.length > 0) {
          filtered.forEach((element) => {
            element["correlationId"] = correlationId;
            if (!isMultiProducts && qta && qta != null) {
              element["quantity"] = qta;
            }
          });

          pObjToBuy = pObjToBuy.concat(filtered);
        }
      } else {
        //ho un prodotto a scaffale, prendo l'elemento singolo
        let filtered = prods.filter((e) => e.code === code && e.bundleCode === null); //c'è il codice tra i prodotti, ma non è associato ad un bundle
        if (filtered && filtered.length > 0) {
          let prodElm = filtered[0];
          prodElm["correlationId"] = correlationId;
          if (!isMultiProducts && qta && qta != null) {
            prodElm["quantity"] = qta;
          }
          pObjToBuy.push(prodElm);
        }
      }
    });

    // ----------- GESTIONE PARAMETRI EXTRA -----------
    pObjToBuy.forEach((p) => {
      p.properties = p.properties && p.properties !== null ? p.properties : {};

      extraParams.forEach((exp) => {
        let val = searchParams.get(exp);
        if (val && val !== null && val.length > 0) {
          p.properties[exp] = val;
        }
      });
    });
    // -------------------------------------------------

    if (!isFreeProd) {
      // ------------ SOLO PRODOTTI PAY

      //setProducts(pObjToBuy);

      //---- SEQUENZA CHIAMATE IN SINCRONO ----------
      API.basketDelAll((data) => {
        if (isLogged && codComm && codComm !== null && codComm.length > 0) {
          //sono loggato e ho una commissione di default, tento di settarla nel cookie

          if (usr.user.commissionList && usr.user.commissionList.commissions && usr.user.commissionList.commissions.length > 0) {
            //verifico prima che ci sia una commissione di quel tipo nel profilo utente
            let verifyComm = usr.user.commissionList.commissions.filter((e) => e.codComm === codComm);
            if (verifyComm && verifyComm.length > 0) {
              API.addValue("CODCOMM", codComm, (data) => {
                sessionStorage.setItem(Fnc.selCCName, JSON.stringify(verifyComm[0])); //la setto anche nello storage locale
                addItemsAndNavigate(pObjToBuy, redirPath);
              });
            }
          } else {
            //utente loggato, mi è arrivata commissione come parametro ma il profilo utente caricato non ha l'elenco delle commissioni (Es: utente da link mail). E' caso anomalo devo farlo andare a loggarsi esplicitamente.
            let logoutinRedir =
              "https://sso.italiaonline.it/websso/logout?auth_ok_url=" + encodeURIComponent(Fnc.currEnv().areaClientiPath + "login?url=" + encodeURIComponent(document.location.href));
            console.log("GO TO LOGIN:", logoutinRedir);
            window.location.href = logoutinRedir;
          }
        } else {
          addItemsAndNavigate(pObjToBuy, redirPath);
        }
      });
    } else {
      // ------------ SOLO PRODOTTI FREE

      if (!isLogged) {
        //ho trovato uno dei prodotti di eccezione, NON sono loggato, quindi la redirect finale cambia
        Fnc.gaTrackRegistrationFreeProd("start", pObjToBuy[0].code, false); //traccia su GA una pagina vista fake per obiettivo canalizzato
        navigate(redirPath);
      } else {
        if (piva && piva != null) {
          //ho trovato uno dei prodotti di eccezione, e sono loggato, quindi la redirect finale cambia e si gestisce l'acquisto diretto.
          Fnc.gaTrackRegistrationFreeProd("start", pObjToBuy[0].code, true); //traccia su GA una pagina vista fake per obiettivo canalizzato
          performBuyFreeProd(usr, piva, pObjToBuy);
        } else {
          //ERRORE : loggato senza parita iva.
          Fnc.gaTrackRegistrationFreeProd("err", pObjToBuy[0].code, true); //traccia su GA una pagina vista fake per obiettivo canalizzato
          Fnc.gaException("[Bridge.js@doJob] Iva vuota durante acquisto prodotto FREE", JSON.stringify(usr), true, Fnc.ExcCatgory.BRIDGE.val);
          navigate(errStep.path + "?err=NOIVA");
        }
      }
    }
  }

  function addItemsAndNavigate(pObjToBuy, redirPath) {
    API.addItem(pObjToBuy, (data) => {
      setLoadingState("");
      navigate(redirPath);
    });
  }

  // ====================== GESTIONE PRODOTTI FREE ACQUISTATI DA LOGGATI DIRETTAMENTE=========================

  function performBuyFreeProd(usr, piva, pObjToBuy) {
    let invoiceData = {};
    invoiceData.piva = piva;
    invoiceData.fCond = true;
    invoiceData.fProm = false;

    //---- SEQUENZA CHIAMATE IN SINCRONO ----------
    API.basketDelAll((data) => {
      //verifico prima quante commissioni ha
      if (usr && usr.user && usr.user.commissionList && usr.user.commissionList && usr.user.commissionList.commissions && usr.user.commissionList.commissions.length > 0) {
        if (usr.user.commissionList.commissions.length === 1) {
          //ho una sola commissione
          let cComm = usr.user.commissionList.commissions[0];
          API.addValue("CODCOMM", cComm.codComm, (data) => {
            //sessionStorage.setItem(Fnc.selCCName, JSON.stringify(verifyComm[0])); //la setto anche nello storage locale
            invoiceData.cc = cComm;
            invoiceData.cc.products = null;
            doDirect(invoiceData, pObjToBuy);
          });
        } else {
          //ho più di una commissione, si è deciso che va fatto un nuovo contratto, non si fa scegliere all'utente dato che è un prodotto free
          invoiceData.cc = {};
          doDirect(invoiceData, pObjToBuy);
        }
      } else {
        Fnc.gaException("[Bridge.js@performBuyFreeProd] Commissione vuota durante acquisto prodotti FREE", JSON.stringify(usr), true, Fnc.ExcCatgory.BRIDGE.val);
        navigate(errStep.path + "?err=NOCOM");
      }
    });
  }

  function doDirect(invoiceData, pObjToBuy) {
    if (pObjToBuy) {
      //ho trovato nel listino l'oggetto prodotto associato a quel codice

      //metto nel carrello il prodotto
      API.addItem(pObjToBuy, (data) => {
        if (data.rule && data.rule.then) {
          //16/5/2023 : ho una rule la gestisco per dare info più corrette nei log e sulla url pagina errore
          Fnc.gaException("[Bridge.js@doDirect] Checkout direct KO per prodotti FREE", JSON.stringify(data), true, Fnc.ExcCatgory.BRIDGE.val);
          navigate(errStep.path + "?err=CKDIKO-" + data.rule.then.code);
        } else {
          //effettuo l'acquisto in direct
          let fpt = Fnc.jsonSerialize(invoiceData);

          API.checkoutDirect(fpt, "1111111111111", (data) => {
            Fnc.log("CHECKOUT DIRECT PRODOTTI FREE OK", data, Fnc.LogLvl.DEBUG);

            if (data && data.response && data.response.code === "OK") {
              //polling sul risultato della creazione ordine
              let orderId = data.id;
              setInterval(function () {
                checkOrderStatus(orderId, pObjToBuy);
              }, 4000);
            } else {
              Fnc.gaException("[Bridge.js@doDirect] Checkout direct KO per prodotti FREE", JSON.stringify(data), true, Fnc.ExcCatgory.BRIDGE.val);
              navigate(errStep.path + "?err=CKDIKO");
            }
          });
        }
      });
    } else {
      Fnc.gaException("[Bridge.js@doDirect] Prodotto vuoto durante acquisto prodotti FREE", JSON.stringify(invoiceData), true, Fnc.ExcCatgory.BRIDGE.val);
      navigate(errStep.path + "?err=NOPRD");
    }
  }

  function checkOrderStatus(orderId, pObjToBuy) {
    API.getOrder(orderId, (data) => {
      if (data && data.response && data.response.code === "OK") {
        //======= CONTROLLO STATO DELL'ORDINE ===
        if (data.orderData && data.orderData.status === "COMPLETED") {
          //OK vado su area clienti sui path corretti per i due prodotti.

          let exc = prodRegistration.find((e) => e.code === pObjToBuy[0].code); //faccio conto che SDIYF o CMFTF si prendono singolarmente [0]
          let redirPath = Fnc.currEnv().areaClientiPath; //default
          if (exc && exc !== null) redirPath = exc.pathDirect;
          let codComm = data.orderData.codComm;
          redirPath = redirPath.replace("#commissioneaddOn#", codComm);

          Fnc.gaTrackRegistrationFreeProd("end", pObjToBuy[0].code, true); //traccia su GA una pagina vista fake per obiettivo canalizzato

          window.location.href = redirPath;
        } else if (data.orderData && (data.orderData.status === "FAILURE" || data.orderData.status === "SF_ERROR" || data.orderData.status === "CAON_ERROR")) {
          //KO mando su pagina errore
          Fnc.gaTrackRegistrationFreeProd("err", pObjToBuy[0].code, true); //traccia su GA una pagina vista fake per obiettivo canalizzato
          Fnc.gaException("[Bridge.js@checkOrderStatus] Stato ordine in ERRORE durante acquisto prodotti FREE", JSON.stringify(data), true, Fnc.ExcCatgory.BRIDGE.val);
          navigate(errStep.path + "?err=003INCOD");
        } else {
          //stati LOOP polling
          Fnc.log("ORDER STATUS : ", data.orderData.status, Fnc.LogLvl.DEBUG);
        }
      } else {
        //errore
        Fnc.gaException("[Bridge.js@checkOrderStatus] Check stato ordine in KO durante acquisto prodotti FREE", JSON.stringify(data), true, Fnc.ExcCatgory.BRIDGE.val);
        navigate(errStep.path + "?err=003KO");
      }
    });
  }

  // ===================================================================

  //----------- RENDER -----------
  return (
    <>
      <Loading loadingState={loadingState} />
    </>
  );
}

export default Bridge;
